export default __webpack_public_path__ + "static/img_8-7ad5f91be75083063c57e63afbf4607a.png";